export default __webpack_public_path__ + "static/image20-72cc36cbe64409211d4d974a19c19829.gif";